import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import isEqual from "lodash/isEqual";
import { css } from 'emotion';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import { TableEdit as DesignTableEdit, Table as DesignTable } from '@whalecloud/fdx';
import { getElement, getParentFormWidthChildren } from '@whalecloud/page-builder-core/components/Render/selectors';
import FormItem from "@whalecloud/page-builder-core/components/Render/components/FormItem";
import { makeEventProps } from '@whalecloud/page-builder-core/utils/common';
import { tableRegExp, calculateScrollWidth, getLocale } from '@utils/util';

const left = css({ textAlign: 'left' });

const handleColumns = (props: any) => {
  const columnsRender: Array<any> = [];
  const columns: Array<any> = [];
  const { element, state, nameSpace } = props;
  const { elements = [] } = element;
  elements.forEach((childId, index) => {
    const child = getElement(state, childId.id, nameSpace);
    columns.push({
      ...child.data.columnSettings,
    });
    columnsRender.push({
      ...child.data.columnSettings,
      title:child.data.columnSettings.editRules?<div><span style={{color:'red'}}>*</span>{child.data.columnSettings.title}</div> :child.data.columnSettings.title,
    });
  });
  return [columnsRender, columns];
};

const TableEdit = props => {
  const messages = getLocale();
  const { element, nameSpace, formElement } = props;
  const [columnsRender] = handleColumns(props);
  const { tableSettings, formSettings, settings, className = '' } = element.data;
  const { horizontalAlign = 'left' } = settings;
  const { scroll, autoInitialize, dataSource = [], disabled = false } = tableSettings;
  const { rules = [] } = formSettings;
  const [scrollWidth, setScrollWidth] = useState(0);

  const eventProps = makeEventProps(element.data.events, nameSpace);
  const ruleProps: any = {};
  if (rules.length > 0) {
    ruleProps.rules = [{ required: rules[0].required, validator: (rule, value) => tableRegExp(rule, value, dataSource, rules[0]) }]
  }

  const handleResize = (len) => {
    setTimeout(() => {
      setScrollWidth(calculateScrollWidth(formElement, element, len, true, 'render'));
    }, 200)
  }

  useEffect(() => {
    window.addEventListener('resize', () => handleResize(columnsRender.length));
    return () => {
      window.removeEventListener('resize', () => handleResize(columnsRender.length));
    }
  }, [scrollWidth]);

  useEffect(() => {
    handleResize(columnsRender.length);
  }, [columnsRender.length]);

  const onSaveRowEdit = (record, newData) => {
    //行编辑保存后触发的回调
    const { formInstance } = formElement.data || {};
    if (formInstance) {
      formInstance.setFieldsValue({ [formSettings.name]: newData });
    }
  }

  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <div style={{ textAlign: horizontalAlign }}>
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-input', left)}
            {...formSettings}
            {...ruleProps}
            valuePropName="dataSource"
          >
            {disabled ? (<DesignTable
              style={elementStyle}
              {...tableSettings}
              columns={columnsRender}
              operColumnTitle={messages['PAGEBUIDER_TABLE_OPERATION']}
              dataSource={autoInitialize ? dataSource : []}
              className={className}
              scroll={{ x: (scroll && scroll.x) || scrollWidth || 0, y: (scroll && scroll.y) || 0 }}
              onRow={record => ({
                onDoubleClick: () => eventProps.onDoubleClick(record) || (() => { }),
                onClick: () => eventProps.onClick(record) || (() => { }),
              })}
              rowSelection={null}
            />) : (<DesignTableEdit
              style={elementStyle}
              {...tableSettings}
              columns={columnsRender}
              operColumnTitle={messages['PAGEBUIDER_TABLE_OPERATION']}
              dataSource={autoInitialize ? dataSource : []}
              className={className}
              scroll={{ x: (scroll && scroll.x) || scrollWidth || 0, y: (scroll && scroll.y) || 0 }}
              {...eventProps}
              onSaveRowEdit={onSaveRowEdit}
              rowSelection={tableSettings.rowSelection ? {
                onChange: (keys, rows) => {
                  eventProps.onSelect && eventProps.onSelect(rows)
                }
              } : null}
              onRow={record => ({
                onDoubleClick: () => eventProps.onDoubleClick(record) || (() => { }),
                onClick: () => eventProps.onClick(record) || (() => { }),
              })}
            />)
            }
          </FormItem>
        </div>
      )}
    </ElementRoot>
  );
};

export default connect<any, any, any>(
  (state, props) =>
    ({ state, formElement: getParentFormWidthChildren(state, props.element.id, props.nameSpace) }),
  null,
  null,
  { areStatePropsEqual: isEqual }
)(TableEdit);
